module.exports = __webpack_public_path__ + "static/media/high_low.656fc0c3.svg";